import styled from 'styled-components'

export const Note = styled.p`
  margin-top: 0;

  a {
    ${props => props.theme.css.link}
  }
`
